module.exports = __webpack_public_path__ + "static/media/cell-mob@2x.d3525f8b.png";